import { makeStyles, Theme } from '@material-ui/core/styles';
import { designTokens } from '../../theming/design-tokens';

const { spacing, borderRadius, typography } = designTokens;

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: borderRadius.lg,
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  headerTitle: {
    fontSize: typography.fontSize['2xl'],
    fontWeight: typography.fontWeight.bold,
    lineHeight: typography.lineHeight.tight,
  },
  headerSubtitle: {
    fontSize: typography.fontSize.md,
    fontWeight: typography.fontWeight.normal,
    color: theme.palette.constrastGreyDarker.main,
    marginTop: spacing.xs,
  },
  content: {
    padding: spacing.lg,
  },
  section: {
    marginBottom: spacing.lg,
  },
  sectionTitle: {
    fontWeight: typography.fontWeight.semibold,
    marginBottom: spacing.sm,
    color: theme.palette.primary.main,
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: borderRadius.base,
      backgroundColor: theme.palette.constrastGreyLighter.main,
    },
  },
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: spacing.md,
    backgroundColor: theme.palette.constrastGreyLighter.main,
    borderRadius: borderRadius.base,
    border: `1px solid ${theme.palette.constrastGreyDark.main}`,
  },
  toggleLabel: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    margin: 0,
  },
  fileUploadContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.md,
    marginTop: spacing.sm,
  },
  fileInput: {
    display: 'none',
  },
  uploadButton: {
    backgroundColor: theme.palette.white.main,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    fontWeight: typography.fontWeight.semibold,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.constrastGreyLight.main,
    },
  },
  demoButton: {
    color: theme.palette.primary.main,
    textTransform: 'none',
    fontWeight: typography.fontWeight.medium,
  },
  helpText: {
    color: theme.palette.constrastGreyDarker.main,
    display: 'block',
    marginBottom: spacing.sm,
  },
  fileInfo: {
    marginTop: spacing.md,
    padding: spacing.md,
    backgroundColor: theme.palette.constrastGreyLight.main,
    borderRadius: borderRadius.base,
    border: `1px solid ${theme.palette.constrastGreyDark.main}`,
    '& .MuiTypography-root': {
      marginBottom: spacing.xs,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  actions: {
    padding: spacing.lg,
    justifyContent: 'flex-end',
    gap: spacing.sm,
  },
  resetButton: {
    backgroundColor: theme.palette.white.main,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    fontWeight: typography.fontWeight.semibold,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.constrastGreyLight.main,
    },
  },
  submitButton: {
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.white.main,
    fontWeight: typography.fontWeight.bold,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.constrastGreyBlack.main,
    },
    '&:disabled': {
      backgroundColor: theme.palette.constrastGreyNormal.main,
      color: theme.palette.constrastGreyDarker.main,
      border: `1px solid ${theme.palette.constrastGreyDark.main}`,
    },
  },
  warningText: {
    marginBottom: spacing.md,
    color: theme.palette.error.main,
  },
  summaryText: {
    marginTop: spacing.sm,
  },
  restaurantListText: {
    marginTop: spacing.sm,
    fontFamily: 'monospace',
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: 0,
    '& .MuiCheckbox-root': {
      transform: 'scale(1.3)',
    },
  },
  checkboxLabel: {
    color: theme.palette.constrastGreyBlack.main,
    fontSize: typography.fontSize.lg,
    fontWeight: typography.fontWeight.bold,
  },
  disableWarningText: {
    marginTop: spacing.md,
    color: theme.palette.error.main,
    fontWeight: typography.fontWeight.semibold,
  },
  dangerButton: {
    backgroundColor: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`,
    color: theme.palette.white.main,
    fontWeight: typography.fontWeight.bold,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

export default useStyles;
